

styles += """
  .main_callout {
    font-size: 42px;
    font-weight: 800;
    color: white;
    text-shadow: 0px 2px 4px rgba(0,0,0,.2);
  }

  .bold_callout {
    font-weight: 800;
    color: #303030;
    font-size: 36px;
    margin: 0 auto 40px auto;
    max-width: 1100px;
    text-align: center;    
  }

  .light_callout {
    font-weight: 300;
    font-size: 38px;
    text-align: center;
    margin-bottom: 4px;
  }

  @media (max-width: 1018px) and (min-width: 600px) {
    .main_callout, .light_callout, .bold_callout {
      font-size: 32px;
    }
  }

  @media (max-width: 600px) and (min-width: 414px)  {
    .main_callout, .light_callout, .bold_callout {
      font-size: 24px;
    }
  }
  @media (max-width: 413px) {
    .main_callout, .light_callout, .bold_callout {
      font-size: 20px;
    }
  }


"""


window.focus_color = -> 
  customization('focus_color') or focus_blue

window.primary_color = -> c = bus_fetch('colors'); c.primary_color

window.seattle_salmon = 'rgb(226 97 98)' #'#ee6061' #'#E16161'


palette = ["#e36263", "#2e8190", "#95377f", "#5f4ac2", "#734487", "#2d5da8"]


Colors = ReactiveComponent
  displayName: 'Colors'
  render: -> 
    loc = bus_fetch 'location'
    colors = bus_fetch 'colors'
    logo_color = 'white'
    color = seattle_salmon

    switch loc.url 
      when '/'
        # logo_red #'#d65931' #'#B03F3A'
        # '#fff'
        color = seattle_salmon # palette[0] # seattle_salmon
      when '/tour'
        #'#EC3684'
        #seattle_salmon
        color = palette[1]  # "rgb(185 57 112)" # "#C11760" #"rgb(46 128 199)" # '#93B344'
      when '/examples', '/examples/public_engagement'          
        color = palette[2] # '#96367E'
      when '/examples/strategic_planning'          
        color = '#647931'
      when '/examples/decentralized_decisions'          
        color = '#205A83'
      when '/examples/community_visioning'
        color = '#324b7a'
      when '/pricing'
        #'#045567'
        color = palette[3] # #5f4ac2 #'#6F3AB0'
        #'#734EA0'
      when '/contact'
        color = palette[4] # "#6378be" # "rgb(112 101 176)" #'#65B08C'

      when '/create_forum'
        # color = '#B03A88'
        color = palette[5] # 'rgb(80 110 192)'
        #'#348ac7'
        #'#4DBE4D'
        #'#414141'

      when '/metrics'
        color = 'white'
        logo_color = seattle_salmon


    if colors.primary_color != color 
      colors.primary_color = color
      colors.logo_color = logo_color
      save colors 
    SPAN null

require './testimonials'
require './demo'
require './landing_page'
require './examples_page'
require './contact'
require './pricing'
require './create_forum'
require './metrics'
require './tour'
require './header'
require './footer'
require './payment'



Page = ReactiveComponent

  displayName: "Page"
  mixins: [ AccessControlled ]

  render: ->
    loc = bus_fetch 'location'    
    
    footer_height = bus_fetch('footer').height

    bg_pattern_opacity = .03 # if loc.url == '/' then 0.025 else 0.04

    doc = bus_fetch 'document'

    update_title = (title) ->
      if doc.title != title 
        doc.title = title 
        save doc


    DIV   
      style: 
        backgroundColor: primary_color()        
        transition: 'background-color 500ms ease'
        backgroundImage: """
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='887' height='739.2' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='#{bg_pattern_opacity}'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")
          """
        minHeight: '100%'
        #margin: if footer_height then "0 auto -#{bus_fetch('footer').height}px"

      if loc.query_params.play_demo
        Video
          playing: true 
      else 
        ProductHeader()

      if loc.url.indexOf('/examples') > -1
        update_title('Examples')        
        ExamplesPage()
      else if loc.url.indexOf('/docs/') > -1
        DocumentationGroup()
      else 
        switch loc.url 
          when '/metrics'
            Metrics()
          when '/'
            update_title('Consider.it')
            LandingPage()
          when '/tour'
            update_title('How it works')
            Tour()
          when '/pricing'
            update_title('Pricing')
            Pricing()            
          when '/contact'
            update_title('Contact us')
            Contact()
          when '/create_forum'
            update_title('Create a forum')
            CreateForum()

      ProductFooter()



Computer = ReactiveComponent
  displayName: 'Computer'

  render: -> 
    SPAN null,
      STYLE dangerouslySetInnerHTML: __html: """
        .big_button {
          background-color: #{primary_color()};
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 50%);
          font-weight: 700;
          color: white;
          padding: 22px 42px;
          display: inline-block;
          font-size: 24px;
          border: none;
          border-radius: 8px;
          text-decoration: none;
          border-bottom: 1px solid black;
        }


      """

window.big_button = -> 
  backgroundColor: primary_color()
  boxShadow: "0 1px 2px 0 rgb(0 0 0 / 50%)"
  fontWeight: 700
  color: 'white'
  padding: '22px 42px'
  display: 'inline-block'
  fontSize: 24
  border: 'none'
  borderRadius: 8
  textDecoration: 'none'
  borderBottom: "1px solid black"


window.BIG_BUTTON = (text, opts) -> 
  opts.style ||= {}
  _.defaults opts.style, big_button()

  BUTTON 
    style: opts.style 
    onClick: opts.onClick
    onKeyPress: (e) -> 
      if e.which == 13 || e.which == 32 # ENTER or SPACE
        e.preventDefault()
        opts.onClick(e)

    text 


styles += """
  .conversion_attempt {
    border-radius: 8px;
    font-size: #{responsive_css_rule({min_size: 16, max_size: 24, min_vw: 414, max_vw: 700})};
    font-weight: 700;
    width: 330px;
    text-align: center;
    padding: 24px 0;
    display: inline-block;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .conversion_attempt.main {
    background-color: #EC3684;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.5);
    color: #FFFFFF;
    margin-right: 48px;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 50%);
    border-bottom: 1px solid black;
  }
  .conversion_attempt.secondary {
    border: 1px solid #585858;
    border-radius: 8px;
  }

"""


window.demo_url = -> 
  region = bus_fetch('/application').region
  return null if !region
  region = region.toLowerCase()
  if region == 'us'
    'https://galacticfederation.consider.it'
  else
    "https://galacticfederation.#{region}.consider.it"


window.conversion_pages = -> 
  create_forum:
    url: '/create_forum'
    label: 'Create a Free Forum'
    small_label: 'Create Forum'
  pricing: 
    url: '/pricing'
    label: 'View Plans'
  demo: 
    url: demo_url()
    external: true
    label: 'Try a Demo'
    small_label: 'Try Demo'
  contact: 
    url: '/contact'
    label: 'Contact Us'
  tour: 
    url: '/tour'
    label: 'Take the Product Tour'
    small_label: 'Take a Tour'
  examples: 
    url: '/examples'
    label: "See Examples"
  about_us: 
    url: '/contact#about_us'
    label: 'About us'

window.ConversionAttempt = ReactiveComponent
  displayName: "ConversionAttempt"

  render: -> 
    first = conversion_pages()[(@props.pages?[0] or 'create_forum')]
    second = conversion_pages()[(@props.pages?[1] or 'pricing')]
 
    w = WINDOW_WIDTH()
    portrait_phone = w < 690


    DIV 
      style: 
        display: 'flex'
        justifyContent: 'center'
        margin: '0px auto'
        padding: "#{responsive_css_rule({min_size: 40, max_size: 80, min_vw: 550, max_vw: 700})} 24px"

      A
        target: if first.external then '_blank'
        className: "conversion_attempt main"
        style: 
          backgroundColor: @props.backgroundColor or primary_color()
        href: first.url

        if portrait_phone && first.small_label
          first.small_label
        else 
          first.label


      A
        target: if second.external then '_blank'      
        className: 'conversion_attempt secondary'
        href: second.url

        if portrait_phone && second.small_label
          second.small_label
        else 
          second.label



styles += """
  #content, #content input, #content button, #content textarea {
    font-family: IBM Plex Sans, Helvetica Neue, sans-serif; 
  }
  .condensed {
    font-family: "Fira Sans Condensed", 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif; 
  }
  .monospaced {
    font-family: Menlo, Consolas, Monaco, Fira Mono, Liberation Mono, Lucida Console, monospace;
  }
  """

Root = ReactiveComponent
  displayName: "Root"

  # Track whether the user is currently swipping. Used to determine whether
  # a touchend event should trigger a click on a link.
  # TODO: I'd like to have this defined at a higher level  
  onTouchMove: -> 
    window.is_swipping = true
  onTouchEnd: -> 
    window.is_swipping = false

  render: ->
    DIV 
      "data-url": bus_fetch('location').url
      style: 
        width: "100vw"

      BrowserLocation()
      BrowserHacks()

      Page()

      Tooltip
        style: 
          #backgroundColor: primary_color()
          # color: 'black'
          # maxWidth: 500
          padding: '16px 24px'
      Popover()
      Computer()
      Colors()


window.Saas = Root



require './app_loader'




/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/product_page.coffee
 **/